import { useEffect, useState } from 'react';

export default function usePortfolioMotion(rootRef) {
  const [paused, setPaused] = useState(false);
  const [reduced, setReduced] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => setReduced(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  const enabled = !paused && !reduced;
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const targets = root.querySelectorAll('.approach-step, .education-feature, .field-challenge, .section-heading, .project-card, .profile-facts, .discipline, .udemy-activity, .research-main, .research-feature, .research-metric, .publication, .experience-row, .contact-title');
    targets.forEach(target => target.classList.add('reveal-item'));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -32px 0px' });
    targets.forEach(target => observer.observe(target));
    let frame = 0;
    const sections = ['home', 'approach', 'work', 'research', 'education', 'journey', 'about', 'contact'].map(id => document.getElementById(id));
    const update = () => {
      frame = 0;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      root.style.setProperty('--read-progress', String(maxScroll > 0 ? window.scrollY / maxScroll : 0));
      root.style.setProperty('--hero-shift', enabled ? `${Math.min(window.scrollY * .13, 90)}px` : '0px');
      let active = 'home';
      sections.forEach(section => { if (section && section.getBoundingClientRect().top <= window.innerHeight * .4) active = section.id; });
      setActiveSection(active);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    };
  }, [enabled, rootRef]);
  return { enabled, reduced, activeSection, toggleMotion: () => setPaused(value => !value) };
}
